module.exports = __webpack_public_path__ + "b33926852a55ce3538b8dc750a6404fb.svg";